import fvSubassembly from "../fvSubassembly"
export default class fvErrorObj extends fvSubassembly {
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }
    }
    onDraw(canvas){
        
    }
    Render (obj,canvas) {
        
    }
    roundRect(canvas,x, y, w, h, r,flag) {
        
    }
    //判断如果圆角最大值不能超过宽高的一半
    changeGrond(obj){
        
    }

}


// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvErrorObj.js